import React from 'react';
import styled from 'styled-components';
import { ButtonPrimary } from '@spotify-internal/encore-web';

import { IntegrationRedirectScreenSection } from './styles';

const IntegrationRedirectScreenConfirmationContent = styled.div`
  text-align: center;
  max-width: 448px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  button {
    margin: 8px;
  }
`;

export function IntegrationRedirectScreenPodcastConfirmation({
  handleSuccess,
  handleLoggedOutRedirect,
}: {
  handleSuccess: () => void;
  handleLoggedOutRedirect: () => void;
}) {
  // TODO https://anchorfm.atlassian.net/browse/CAST-2965: Utilized new Podcast Confirmation component
  // once design systems team has finished it
  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Update to finalize text and translate
  return (
    <IntegrationRedirectScreenSection>
      <IntegrationRedirectScreenConfirmationContent>
        <ButtonPrimary onClick={handleSuccess}>CONFIRM</ButtonPrimary>
        <ButtonPrimary onClick={handleLoggedOutRedirect}>
          CHOOSE DIFFERENT ACCOUNT
        </ButtonPrimary>
      </IntegrationRedirectScreenConfirmationContent>
    </IntegrationRedirectScreenSection>
  );
}
